import '@hapana/shared/utils/type-defs.util'

/** @type {Styles} */

export const styles = {
  container: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    paddingLeft: 0,
    width: '100%',
    cursor: 'pointer',
    border: 0,
    backgroundColor: 'transparent',
    paddingX: 2,
    paddingY: 1.5,
  },
  icon: {
    color: 'gray.80',
  },
  alertIcon: {
    width: 13,
    height: 13,
  },
  viewAllAlerts: {
    marginLeft: '12px',
    marginRight: '2px',
  },
  divider: {
    borderColor: 'gray.8',
  },
}
